<template>
  <v-card class="m-5 ma-1" >



         <v-container fluid grid-list-lg>
              <v-layout @click="toCollection1" row>
                <v-flex xs8>
                  <div>
                    <div @click="toCollection" style="text-decoration:none;  cursor:pointer" class="headline">{{collection.title[lang].slice(0, 40)}}<span v-if="collection.title.length >39">...</span></div>
                    <div class="greyText">{{collection.description[lang].slice(0, 100)}}<span v-if="collection.description[lang].length >99">...</span></div>
                  </div>
                </v-flex>
                <v-flex xs4>
                  <v-layout justify-end> 
                  <v-card-media class="mt-2 mr-2" style="width:110px; min-width:110px"
                    :src="collection.imgUrl[0].url+'_card'"
                    height="110px"
                    cover
                  ></v-card-media>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
        
        <v-expansion-panel class="expPanel" v-if="showContent(collection)" expand >
            <v-expansion-panel-content class="mb-0" style="    width: 100%;" >


                <div class="greyText" slot="header"><v-icon left class="pr-2">view_day</v-icon>{{gLang[lang].collectionCard.expansion}}</div>
  


              <v-layout row>
    <v-flex xs12 sm12 >
      <v-card>
        <v-list two-line>
          <template >
            <div v-for="(artefact,i) in relatedArtefacts" :key="i">
             
            <v-divider v-if="i<3"></v-divider> 
            <v-list-tile @click="toArtefact(artefact._id)" avatar v-if="i<3" class="pt-2 pb-0" >
              <v-list-tile-avatar>
                <img v-bind:src="artefact.mainImg[0].url+'_card'"/>
              </v-list-tile-avatar>
              <v-list-tile-content style="height:auto;" class="collection-list-ie">
                <v-list-tile-title class="artTitle" v-html="artefact.title[lang]"></v-list-tile-title>
                <v-list-tile-sub-title v-for="(user,i) in users" :key="i" v-if="artefact.userId.indexOf(user._id) > -1" ><span class="author">{{user.displayName}}</span>  <span>- {{artefact.description[lang]}}</span></v-list-tile-sub-title>
                
                             
              </v-list-tile-content>
               
            </v-list-tile>
              </div>
           
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>

            </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>

</template>

<style>
.expPanel .expansion-panel__container .expansion-panel__header {
  padding-left:15px;
}
</style>




<script>
export default {
  props: ['collection', 'artefacts','clickImage'],

  data()
    {
        return {
        direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      count:0,
      top: false,
      right: true,
      bottom: true,
      left: false,
      count:0,
      transition: "slide-y-reverse-transition",
         
        }
    },
    methods: { 
      toCollection() {
        this.$router.push('/collections/'+this.collection._id);
      },
      toCollection1() {
        if (this.clickImage != false)
        this.$router.push('/collections/'+this.collection._id);
        else if(window.innerWidth>950)
        this.$router.push('/collections/'+this.collection._id);
      },
      toArtefact(artefactID) {
        this.$router.push('/artefacts/'+artefactID);
        
      },
      filterUser(userId) {
      return  this.users.filter((user) => {
                    return (user._id == userId)
                })
      
      },
      increase1() {
        this.count++;
        if(this.count<6)
          return true;
        return false;
      },
    //  moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';
        
    //     }
    //     else 
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }

        
    //   },
    showContent(collection) { 

      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      if(this.relatedArtefacts.length > 0)
      return true
      return false;
    },

    minimize(str,spaces){
      
      if(str.split(' ').length < spaces)
      return str
      else 
      return str.split(' ').slice(0, spaces-1).join(' ') + '...'
    },
        isLast(idart,coltitle){
      var j,k=[];
  
      
        for (j = 0; j<this.artefacts.length;j++)
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1)
        k.push(this.artefacts[j]._id);

    if(k[k.length-1] == idart)
    return true
    else return false

    }
  },
  mounted(){
    this.$store.dispatch('loadUsers');
  },
  computed:{
    lang() {
      return this.$store.getters.loadLang;
    },
    gLang() {
      return this.$store.getters.loadGlobLang;
    },
    relatedArtefacts() {
      return this.$store.getters.loadRelatedArtefacts(this.collection.title.en)
    },
    users() {
      return this.$store.getters.loadUsers;
    }
  }
}
</script>



<style>

.artTitle{
  font-weight:600;
}

.greyText{
  color:rgba(0, 0, 0, 0.54)
;

}

.author {

  color:black!important;
  font-weight:500;
}

.greyback
{
    background: #efefef;
}


.expansion-panel__container, .expansion-panel__container--active {
  margin-top:0px !important;
}

</style>

<style scoped>


/* @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) { */
    .collection-list-ie {
      display: inline;
    }
/* } */

.collectionCardImage {
  width:100px;
  height: 100px;
}

@media screen and (min-width:950px) { 
.cardCursor:hover { 
  cursor:pointer;
}
}
.div1 {
  position: absolute;
  width: 67%;
    white-space: normal;
}

.group-title{
  color:white;
    font-size: 2.2em !important;
    top:3%;
}

.group-subheading { 
  position: absolute;

        font-size: 1.06em !important;
    top: 101%;
        left: 4%;
        color: white;

}

.collection-title { 
  color:black;
    font-size: 1.5em !important;
    top:3%;
}

.collection-subheading {
    position: absolute;

        font-size: 1.06em !important;
    top: 101%;
        left: 4%;
        color: black;

}

.headline {

      -webkit-text-stroke-width: 0.3px;
    -webkit-text-stroke-color: black;
}


.card-tile-1 {
  width: 100%;
}




</style>



// WEBPACK FOOTER //
// src/components/Partials/CollectionCard.vue